import { Box, Grid, Paper } from "@mui/material";
import bookACallImg from "../../Mycomponent/Assets/home/services-book-a-call.png";
import phoneSvg from "../../Mycomponent/Assets/common/phone.svg";

const Services = () => {
  const services_array = [
    {
      title: "Data Analytics & Insights",
      desc: "Gain a deeper understanding of your customers and marketing performance through forecasting, full-funnel exploration, and campaign impact analyses.",
    },
    {
      title: "User Experience (UX)",
      desc: "Improve the UX for websites and landing pages using a combination of design best practices, page engagement data, competitive analysis, and user testing.",
    },
    {
      title: "Dashboard Development",
      desc: "Our dashboards provide easy-to-read marketing performance visuals based on your preferred metrics hierarchy.",
    },
    {
      title: "Conversion Rate Optimization",
      desc: "Increase conversion rates and decrease customer acquisition costs through improved testing programs.",
    },
    {
      title: "Ad Operations",
      desc: "Integrate new or existing marketing platforms. Create, implement, and QA site tags and data integrations to stay ahead of media landscape changes.",
    },
    {
      title: "Front End Development",
      desc: "Transform website design ideas into reality with seamless UX and innovative, data-driven web development solutions.",
    },
  ];
  return (
    <Paper
      elevation={3}
      sx={{
        padding: "10px",
        width: "100%",
        maxWidth: "900px", // Set a max width for large screens
        margin: "auto",
        cursor: "default"
      }}
    >
      <Box
        className="d-flex align-items-center gap-3 w-100"
        sx={{ height: "335px" }}
      >
        {/* <Box
          sx={{
            width: `calc(100% - 250px)`,
          }}
        >
          <h3 className="heading-large">Focus Areas</h3>
          <Grid container spacing={1}>
            {services_array.map((service) => {
              return (
                <Grid xs={6} item key={service.title}>
                  <h4 className="heading-medium font-light-bold">
                    {service.title}
                  </h4>
                  <p
                    className="heading-xs font-regular mb-2"
                    style={{ color: "rgb(99, 99, 99)" }}
                  >
                    {service.desc}
                  </p>
                </Grid>
              );
            })}
          </Grid>
        </Box> */}
        <Box
          className="h-100 d-flex flex-column align-items-center"
          sx={{
            backgroundImage: `url(${bookACallImg})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "100% 100%",
            width: "250px",
            padding: "5px",
          }}
        >
          <h3
            className="heading-xlarge font-light-bold text-center mt-2 mb-4"
            style={{ color: "#6254FF" }}
          >
            Discover Growth Opportunities at SERPs
          </h3>
          <p className="heading-small font-regular text-center my-3 text-white">
            Access actionable data and insights with modern SEO solutions.
            Partner with us and grow your ROI exponentially.
          </p>
          <a
            href="https://lp.rankspro.io/book-a-call-with-rankspro"
            target="_blank"
          >
            <span
              style={{
                backgroundColor: "#FFFFFF",
                color: "#6254FF",
                padding: "10px",
                borderRadius: "5px",
              }}
              className="heading-small font-light-bold"
            >
              <img src={phoneSvg} alt="" className="me-1" /> Schedule A Call
            </span>
          </a>
        </Box>
      </Box>
    </Paper>
  );
};

export default Services;
